module.exports = __webpack_public_path__ + "static/media/WireRope1.b09f1c2a.webp";